import * as React from 'react';

import Checkbox from '@mui/material/Checkbox';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import styles from './image-item.module.css';

interface Props {
  readonly disabled: boolean;
  readonly filename: string;
  readonly url: string;
  readonly thumbUrl: string;
  readonly onClick: React.MouseEventHandler;
  readonly isOnline: boolean;
  readonly isSelected: boolean;
  readonly isChecked: boolean;
  readonly onPreviewClick: React.MouseEventHandler;
  readonly onCheckboxChange: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
}

export class ImageItem extends React.Component<Props> {
  render() {
    let containerClassToUse = styles.container;

    if (this.props.isSelected) {
      containerClassToUse = styles.containerSelected;
    }

    return (
      <div className={containerClassToUse}>
        <img className={styles.image}
          onClick={this.props.onClick}
          src={this.props.thumbUrl || this.props.url} alt="" />
        <div className={styles.checkbox}>
          <Checkbox
            disabled={this.props.disabled}
            className={styles.innerCheckbox}
            checked={this.props.isChecked}
            onChange={(ev, checked) => {
              this.props.onCheckboxChange(ev, checked);
            }} />
        </div>
        <div className={styles.openPreview} onClick={this.props.onPreviewClick}>
          <RemoveRedEyeIcon>remove_red_eye</RemoveRedEyeIcon>
        </div>
      </div>
    );
  }
}
